<template lang="pug">
  .event-header(ref='change')
    .event-header__wrap
      .title(ref='title')
        p {{ title }} ({{eventQuantity}})
        .title__types
          .title__type
            lei-popover(text="Completed legal entity events.") Completed
          .title__type
            lei-popover(text="Legal entity events in progress.") In progress
          .title__type
            lei-popover(text="Legal entity events withdrawn or cancelled.") Withdrawn canceled
    .event-header__content(ref='content')
      slot
</template>

<script>
import LeiPopover from '@/components/lei-components/LeiPopover'

export default {
  name: 'EventHeader',
  components: {
    LeiPopover,
  },

  props: {
    title: {
      type: String,
      required: true,
    },
    eventQuantity: {
      type: Number,
      required: true,
      default: 0,
    },
  },
  mounted () {
    window.addEventListener('resize', this.setContentWidth)
  },
  destroyed () {
    window.removeEventListener('resize', this.setContentWidth)
  },
  methods: {
    setContentWidth () {
      if (!this.$refs.title && !this.$refs.content) return

      const titleWidth = Number((this.$refs.title.style.maxWidth).slice(0, -2))
      const contentWidth = Math.round(this.$refs.content.getBoundingClientRect().width)

      if (titleWidth !== contentWidth || !this.$refs.title.style.maxWidth && contentWidth !== 0) {
        this.$refs.title.style.maxWidth = Math.round(contentWidth) + 'px'
      }
    },
  },
}
</script>

<style scoped lang="stylus">
  @import "../../../assets/styles/variables.styl"

  .event-header
    position relative
    width: 100%

    &__wrap
      min-height: 48px
      width: 100%

      .title
        display: grid
        grid-template-columns: 100px 1fr
        margin-bottom: 2px
        width: inherit
        max-width: inherit
        background-color: $default-color-light-1
        color: $default-color-bold
        font-weight: 600;
        padding: 15px 20px

        &__types
          justify-self end

        &__type
          margin-left 50px
          font-weight 400
          display inline-block
          position relative
          &::before
            content ''
            position absolute
            top 5px
            left -30px
            display inline-block
            width 15px
            height 15px
            border-radius 7.5px
          &:nth-child(1)
            &::before
              background-color $success-color
          &:nth-child(2)
            &::before
              background-color $warning-color
          &:nth-child(3)
            &::before
              background-color $danger-color

  @media (max-width: $tablet)
    .event-header
      .title
        background-color:$white-color
        grid-template-columns: auto
        &__types
          margin-top 20px
          justify-self start
        &__type
          &:nth-child(1)
            margin-left 30px

  @media (max-width: 605px)
    .event-header
      .title
        &__type
          display block
          margin-left 30px

</style>



// WEBPACK FOOTER //
// src/components/record-details/modifications/EventHeader.vue